import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Import your images
import kabiniLogo from '../assets/images/kabini logo.jpg';
import saffronImg from '../assets/images/safron.webp';
import termericImg from '../assets/images/termeric.webp';
import chiaImg from '../assets/images/chia.jpg';
import bayLeavesImg from '../assets/images/bay.webp';
import gingerImg from '../assets/images/ginger.jpg';
import thymeImg from '../assets/images/thyme.webp';
import isoImg from '../assets/images/iso.webp';
import fssaiImg from '../assets/images/FSSAI_logo.png';
import msmeImg from '../assets/images/msme.png';
import patternImg from '../assets/images/pattern1.png';

const AgroIndex = () => {
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 800,
      once: false,
      mirror: true,
      offset: 40,
      easing: 'ease-out-quad'
    });

    // Cart functionality
    const addToCartButtons = document.querySelectorAll('.add-to-cart');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function() {
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) {
          let count = parseInt(cartCount.textContent);
          cartCount.textContent = count + 1;
          
          // Simple animation
          this.style.transform = 'scale(0.95)';
          setTimeout(() => {
            this.style.transform = 'scale(1)';
          }, 100);
        }
      });
    });

    // Preloader hide after page load
    const preloader = document.querySelector('.preloader');
    if (preloader) {
      setTimeout(() => {
        preloader.style.opacity = '0';
        preloader.style.visibility = 'hidden';
      }, 500);
    }

    // Cleanup function
    return () => {
      // Cleanup event listeners if needed
    };
  }, []);

  // Slick carousel settings for spices
  const spiceSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  // Spices data
  const spices = [
    {
      id: 1,
      name: 'Saffrons',
      pack: '10 g pack',
      price: 'Rs.4000',
      originalPrice: 'Rs.6.99',
      image: saffronImg
    },
    {
      id: 2,
      name: 'Turmeric',
      pack: '1 Kg pack',
      price: 'Rs.350',
      originalPrice: 'Rs.3.99',
      image: termericImg
    },
    {
      id: 3,
      name: 'Chia seeds',
      pack: '1 kg pack',
      price: 'Rs.400',
      originalPrice: 'Rs.4.49',
      image: chiaImg
    },
    {
      id: 4,
      name: 'Bay Leaves',
      pack: '500g pack',
      price: 'Rs.300',
      originalPrice: 'Rs.5.99',
      image: bayLeavesImg
    },
    {
      id: 5,
      name: 'Black Pepper',
      pack: '500g pack',
      price: 'Rs.450',
      originalPrice: 'Rs.7.99',
      image: saffronImg // Replace with actual image
    },
    {
      id: 6,
      name: 'Cinnamon',
      pack: '250g pack',
      price: 'Rs.280',
      originalPrice: 'Rs.5.99',
      image: termericImg // Replace with actual image
    }
  ];

  // Social Icons SVG Sprites
  const socialIcons = (
    <svg style={{ display: 'none' }}>
      <symbol id="facebook" viewBox="0 0 24 24">
        <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z"/>
      </symbol>
      <symbol id="twitter" viewBox="0 0 24 24">
        <path d="M23.953 4.57a10 10 0 0 1-2.825.775 4.958 4.958 0 0 0 2.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 0 0-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 0 0-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 0 1-2.228-.616v.06a4.923 4.923 0 0 0 3.946 4.827 4.996 4.996 0 0 1-2.212.085 4.937 4.937 0 0 0 4.604 3.417 9.868 9.868 0 0 1-6.102 2.104c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 0 0 7.557 2.209c9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63a9.936 9.936 0 0 0 2.46-2.548l-.047-.02z"/>
      </symbol>
      <symbol id="linkedin" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451c.979 0 1.771-.773 1.771-1.729V1.729C24 .774 23.204 0 22.225 0z"/>
      </symbol>
      <symbol id="instagram" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.405a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z"/>
      </symbol>
      <symbol id="youtube" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </symbol>
    </svg>
  );

  // Add all the CSS styles in a style tag
  const styles = `
    :root {
      --fresh-green: #4CAF50;
      --fresh-green-dark: #388E3C;
      --fresh-orange: #FF9800;
      --fresh-yellow: #FFC107;
      --bg-light: #F8F9FA;
    }

    /* Preloader Styles */
    .preloader {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      z-index: 9999;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: opacity 0.5s ease, visibility 0.5s ease;
    }

    .loader {
      width: 48px;
      height: 48px;
      border: 5px solid var(--fresh-green);
      border-bottom-color: transparent;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    /* Product Card Styles */
    .product-card {
      transition: all 0.3s ease;
      border: 1px solid #eee;
      margin: 0 10px;
    }
    
    .product-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    }
    
    .category-badge {
      background: var(--fresh-green);
      color: white;
      padding: 5px 15px;
      border-radius: 25px;
      font-size: 14px;
    }
    
    .price-tag {
      color: var(--fresh-green-dark);
      font-weight: bold;
      font-size: 1.4rem;
    }
    
    .add-to-cart {
      background: var(--fresh-green);
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 25px;
      transition: all 0.3s;
    }
    
    .add-to-cart:hover {
      background: var(--fresh-green-dark);
    }
    
    .organic-badge {
      background: var(--fresh-orange);
      color: white;
      padding: 3px 10px;
      border-radius: 15px;
      font-size: 12px;
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 10;
    }
    
    .cart-icon {
      position: relative;
    }
    
    .cart-count {
      position: absolute;
      top: -8px;
      right: -8px;
      background: var(--fresh-orange);
      color: white;
      border-radius: 50%;
      padding: 2px 6px;
      font-size: 12px;
    }
    
    .hero-section {
      background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('images/vegetables-hero.jpg');
      background-size: cover;
      background-position: center;
      color: white;
      padding: 100px 0;
    }
    
    .feature-icon {
      font-size: 2.5rem;
      color: var(--fresh-green);
      margin-bottom: 1rem;
    }
    
    .social-icon {
      font-size: 1.2rem;
      color: #666;
      transition: color 0.3s;
    }
    
    .social-icon:hover {
      color: var(--fresh-green);
    }
    
    .btn-primary {
      background-color: var(--fresh-green) !important;
      border-color: var(--fresh-green) !important;
    }
    
    .btn-primary:hover {
      background-color: var(--fresh-green-dark) !important;
      border-color: var(--fresh-green-dark) !important;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(76, 175, 80, 0.3);
    }
    
    .text-primary {
      color: var(--fresh-green) !important;
    }

    .navbar-toggler .navbar-icon {
      color: black;
    }

    /* Certificate Card Styles */
    .certificate-card {
      transition: all 0.3s ease;
      border: 1px solid #eee;
      height: 100%;
    }

    .certificate-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 40px rgba(0,0,0,0.1) !important;
      border-color: var(--fresh-green);
    }

    .certificate-card i {
      transition: transform 0.3s ease;
    }

    .certificate-card:hover i {
      transform: scale(1.1);
    }

    .certificate-card h5 {
      color: #333;
      font-size: 1.1rem;
    }

    .certificate-card p {
      margin-bottom: 0.5rem;
      line-height: 1.6;
    }

    .certificate-card .text-muted {
      font-size: 0.9rem;
    }

    /* Stats Section Animation */
    #info .display-1 {
      animation: fadeInUp 1s ease;
    }

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    /* Pattern Image Styles */
    .position-relative img {
      opacity: 0.9;
      transition: opacity 0.3s ease;
    }

    .position-relative:hover img {
      opacity: 1.5;
    }

    /* Slick Carousel Custom Styles */
    .slick-slider {
      margin: 0 -10px;
    }

    .slick-slide {
      padding: 0 10px;
    }


    .slick-dots li button:before {
      font-size: 12px;
      color: var(--fresh-green);
      opacity: 0.5;
    }

    .slick-dots li.slick-active button:before {
      opacity: 1;
      color: var(--fresh-green);
    }

    /* Button Arrow Effect */
    .btn-arrow {
      position: relative;
      overflow: hidden;
      transition: all 0.3s ease;
    }

    .btn-arrow i {
      transition: transform 0.3s ease;
    }

    .btn-arrow:hover i {
      transform: translateX(5px);
    }

    /* Social Icons Hover */
    .social-links .social {
      transition: transform 0.3s ease;
    }

    .social-links .social:hover {
      transform: translateY(-3px);
    }

    .social-links svg {
      fill: #666;
      transition: fill 0.3s ease;
    }

    .social-links .social:hover svg {
      fill: var(--fresh-green);
    }

    /* Responsive Styles */
    @media (max-width: 768px) {
      .certificate-card {
        padding: 1.5rem !important;
      }
      
      .certificate-card h5 {
        font-size: 1rem;
      }

      .display-1 {
        font-size: 3rem;
      }

      .padding-side {
        padding-left: 1rem;
        padding-right: 1rem;
      }

     
    }

    /* Header Top Styles */
    .header-top {
      background-color: #f8f9fa;
      border-bottom: 1px solid #eee;
    }

    .header-top .info li {
      color: #666;
    }

    .header-top .info li i {
      margin-right: 5px;
    }

    /* Navbar Styles */
    #primary-header {
      background: white;
      box-shadow: 0 2px 10px rgba(0,0,0,0.05);
    }

    .navbar-nav .nav-link {
      position: relative;
      padding: 5px 0 !important;
    }

    .navbar-nav .nav-link::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 2px;
      background: var(--fresh-green);
      transition: width 0.3s ease;
    }

    .navbar-nav .nav-link:hover::after,
    .navbar-nav .nav-link.active::after {
      width: 100%;
    }

    /* Dropdown Menu Animation */
    .dropdown-menu {
      display: block;
      opacity: 0;
      visibility: hidden;
      transform: translateY(10px);
      transition: all 0.3s ease;
    }

    .dropdown:hover .dropdown-menu {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }

    .dropdown-item {
      transition: all 0.3s ease;
    }

    .dropdown-item:hover {
      background: var(--fresh-green);
      color: white !important;
      padding-left: 20px;
    }

    /* Form Styles */
    #form {
      box-shadow: 0 20px 40px rgba(0,0,0,0.1);
    }

    #form input {
      border: 1px solid #eee;
      padding: 12px;
      transition: all 0.3s ease;
    }

    #form input:focus {
      border-color: var(--fresh-green);
      box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
      outline: none;
    }

    /* Logo Animation */
    .logo {
      transition: transform 0.3s ease;
    }

    .logo:hover {
      transform: scale(1.05);
    }
  `;

  return (
    <div className="agro-index">
      {/* Inject Styles */}
      <style>{styles}</style>

      {/* SVG Sprites */}
      {socialIcons}

      {/* Preloader */}
      <div className="preloader">
        <div className="loader"></div>
      </div>

      {/* Header */}
      <header id="header">
        <nav className="header-top py-1">
          <div className="container-fluid padding-side">
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <ul className="info d-flex flex-wrap list-unstyled m-0">
                <li className="location text-capitalize d-flex align-items-center me-4" style={{ fontSize: '14px' }}>
                  <i className="fa fa-map-marker-alt" style={{ color: '#388E3C' }}></i> HD Kote Taluk, Karapura, Around Mysore - 571 114
                </li>
                <li className="phone d-flex align-items-center me-4" style={{ fontSize: '14px' }}>
                  <i className="fa fa-phone" style={{ color: '#388E3C' }}></i>9886228154
                </li>
                <li className="time d-flex align-items-center me-4" style={{ fontSize: '14px' }}>
                  <i className="fa fa-envelope" style={{ color: '#388E3C' }}></i>Info@kabinee.com
                </li>
              </ul>
              <ul className="social-links d-flex flex-wrap list-unstyled m-0">
                <li className="social">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#facebook"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#twitter"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#linkedin"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#instagram"></use>
                    </svg>
                  </a>
                </li>
                <li className="social ms-4">
                  <a href="#">
                    <svg className="social" width="16" height="16">
                      <use xlinkHref="#youtube"></use>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <nav id="primary-header" className="navbar navbar-expand-lg py-4">
          <div className="container-fluid padding-side">
            <div className="d-flex justify-content-between align-items-center w-100">
              <Link className="navbar-brand" to="/">
                <img src={kabiniLogo} className="logo img-fluid" style={{ width: '18%' }} alt="Kabini Logo" />
              </Link>

              {/* Navbar Toggler Button */}
              <button className="navbar-toggler border-0 d-flex d-lg-none order-3 p-2 shadow-none" type="button"
                data-bs-toggle="offcanvas" data-bs-target="#bdNavbar" 
                aria-controls="bdNavbar" aria-expanded="false">
                <svg className="navbar-icon" width="40" height="40" style={{ color: '#000000', fill: 'currentColor' }}>
                  <rect x="10" y="12" width="20" height="2" fill="currentColor"/>
                  <rect x="10" y="22" width="20" height="2" fill="currentColor"/>
                  <rect x="10" y="32" width="20" height="2" fill="currentColor"/>
                </svg>
              </button>

              <div className="header-bottom offcanvas offcanvas-end" id="bdNavbar" aria-labelledby="bdNavbarOffcanvasLabel">
                <div className="offcanvas-header px-4 pb-0">
                  <h5 className="offcanvas-title" id="bdNavbarOffcanvasLabel">Menu</h5>
                  <button type="button" className="btn-close btn-close-black" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body align-items-center justify-content-center">
                  <div className="search d-block d-lg-none m-4"></div>
                  <ul className="navbar-nav align-items-center mb-2 mb-lg-0">
                    <li className="nav-item px-3">
                      <Link className="nav-link active p-0 fw-bold" aria-current="page" to="/agroindex">Home</Link>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/about">About</Link>
                    </li>
                    <li className="nav-item px-3 dropdown">
                      <Link className="nav-link p-0 dropdown-toggle fw-bold" data-bs-toggle="dropdown" to="#" role="button" aria-expanded="false">Products</Link>
                      <ul className="dropdown-menu dropdown-menu-end animate slide mt-3 border-0 shadow">
                        {/* <li><Link to="/fruits" className="dropdown-item fw-bold">Fruits</Link></li> */}
                        <li><Link to="/vegetables" className="dropdown-item fw-bold">Vegetables</Link></li>
                        <li><Link to="/spices" className="dropdown-item fw-bold">Spices</Link></li>
                      </ul>
                    </li>
                    <li className="nav-item px-3">
                      <Link className="nav-link p-0 fw-bold" to="/acontact">Contact</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Hero Slider Section */}
      <section id="slider" data-aos="fade-up">
        <div className="container-fluid padding-side">
          <div className="d-flex rounded-5 overflow-hidden"
            style={{
              background: "linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url('https://images.unsplash.com/photo-1610348725531-843dff563e2c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')",
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              height: '610px',
              backgroundPosition: 'center'
            }}>
            <div className="row align-items-center m-auto pt-5 px-4 px-lg-0">
              <div className="text-start col-md-6 col-lg-5 col-xl-6 offset-lg-1 text-white">
                <h2 className="display-1 fw-normal" style={{ color: 'white' }}>Fresh from the Farm to Your Table</h2>
                <p className="lead" style={{ color: 'white' }}>100% organic vegetables and fruits, delivered fresh daily</p>
                <Link to="#" className="btn btn-arrow btn-primary mt-3">
                  <span style={{ color: 'white' }}>Shop Now <i className="fas fa-arrow-right ms-2"></i></span>
                </Link>
              </div>
              <div className="col-md-6 col-lg-5 col-xl-4 mt-5 mt-md-0">
                <form id="form" className="form-group flex-wrap bg-white p-5 rounded-4 ms-md-5">
                  <h3 className="display-5">Get Fresh Updates</h3>
                  <p>Subscribe for weekly updates</p>
                  <div className="col-lg-12 my-4">
                    <label className="form-label text-uppercase">Your Name</label>
                    <input type="text" className="form-control" placeholder="Enter your name" />
                  </div>
                  <div className="col-lg-12 my-4">
                    <label className="form-label text-uppercase">Email Address</label>
                    <input type="email" className="form-control" placeholder="Enter your email" />
                  </div>
                  <div className="d-grid">
                    <button type="button" className="btn btn-arrow btn-primary mt-3">
                      <span style={{ color: 'white' }}>Subscribe Now <i className="fas fa-arrow-right ms-2"></i></span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <br /><br />

      {/* About Us Section */}
      <section id="about-us">
        <div className="container-fluid padding-side" data-aos="fade-up">
          <h3 className="display-3 text-center fw-normal col-lg-4 offset-lg-4">Farm Fresh Goodness</h3>
          <div className="row align-items-start mt-3 mt-lg-5">
            <div className="col-lg-6">
              <div className="p-5">
                <p>Welcome to FreshHarvest, your premier destination for the freshest organic vegetables and fruits. We partner with local farmers to bring you produce that's harvested at peak ripeness and delivered to your doorstep within 24 hours.</p>
                <div className="d-flex gap-4 mt-4">
                  <div className="text-center">
                    <i className="fas fa-leaf feature-icon"></i>
                    <p>100% Organic</p>
                  </div>
                  <div className="text-center">
                    <i className="fas fa-truck feature-icon"></i>
                    <p>Free Delivery</p>
                  </div>
                  <div className="text-center">
                    <i className="far fa-clock feature-icon"></i>
                    <p>24hr Harvest</p>
                  </div>
                </div>
                <Link to="#" className="btn btn-arrow btn-primary mt-3">
                  <span style={{ color: 'white' }}>Learn More <i className="fas fa-arrow-right ms-2"></i></span>
                </Link>
              </div>
              <img 
                src="https://images.unsplash.com/photo-1542838132-92c53300491e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="Fresh vegetables" 
                className="img-fluid rounded-4 mt-4" 
              />
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <img 
                src="https://images.unsplash.com/photo-1610832958506-aa56368176cf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="Fresh fruits" 
                className="img-fluid rounded-4" 
              />
              <img 
                src="https://images.unsplash.com/photo-1615485290382-441e4d049cb5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="Organic farm" 
                className="img-fluid rounded-4 mt-4" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section id="info">
        <div className="container" data-aos="fade-up">
          <div className="row">
            <div className="col-md-3 text-center mb-4 mb-lg-0">
              <h3 className="display-1 fw-normal text-primary position-relative">15K+ <span className="position-absolute top-50 end-50 translate-middle z-n1 ps-lg-4 pt-lg-4">
                <img src={patternImg} alt="pattern" className="img-fluid" />
              </span></h3>
              <p className="text-capitalize">Happy Customers</p>
            </div>
            <div className="col-md-3 text-center mb-4 mb-lg-0">
              <h3 className="display-1 fw-normal text-primary position-relative">200+ <span className="position-absolute top-50 translate-middle z-n1">
                <img src={patternImg} alt="pattern" className="img-fluid" />
              </span></h3>
              <p className="text-capitalize">Farm Partners</p>
            </div>
            <div className="col-md-3 text-center mb-4 mb-lg-0">
              <h3 className="display-1 fw-normal text-primary position-relative">50+ <span className="position-absolute top-100 pb-5 translate-middle z-n1">
                <img src={patternImg} alt="pattern" className="img-fluid" />
              </span></h3>
              <p className="text-capitalize">Product Varieties</p>
            </div>
            <div className="col-md-3 text-center mb-4 mb-lg-0">
              <h3 className="display-1 fw-normal text-primary position-relative">24/7 <span className="position-absolute top-50 end-50 pb-lg-4 pe-lg-2 translate-middle z-n1">
                <img src={patternImg} alt="pattern" className="img-fluid" />
              </span></h3>
              <p className="text-capitalize">Delivery Service</p>
            </div>
          </div>
        </div>
      </section>

      {/* Spices Section with Slick Carousel */}
      <section id="vegetables" className="padding-medium">
        <div className="container-fluid padding-side" data-aos="fade-up">
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            <div>
              <h3 className="display-3 fw-normal text-center">Spices</h3>
            </div>
            <Link to="/spices" className="btn btn-arrow btn-primary mt-3">
              <span style={{ color: 'white' }}>View All <i className="fas fa-arrow-right ms-2"></i></span>
            </Link>
          </div>

          <div className="mt-5">
            <Slider {...spiceSliderSettings}>
              {spices.map((spice) => (
                <div key={spice.id}>
                  <div className="product-card position-relative bg-white rounded-4 overflow-hidden p-3">
                    <span className="organic-badge">Organic</span>
                    <img 
                      src={spice.image} 
                      alt={spice.name} 
                      className="img-fluid rounded-4" 
                      style={{ height: '250px', width: '100%', objectFit: 'cover' }} 
                    />
                    <div className="product-content text-center mt-3">
                      <h4 className="display-6 fw-normal">{spice.name}</h4>
                      <p className="text-muted">{spice.pack}</p>
                      <p>
                        <span className="price-tag">{spice.price}</span> 
                        <span className="text-muted text-decoration-line-through ms-2">{spice.originalPrice}</span>
                      </p>
                      <button className="add-to-cart w-100">
                        <i className="fas fa-shopping-cart me-2"></i>
                        Add to Cart
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
<br/>
<br/>


      {/* Fresh Vegetables Section */}
      <section id="fruits">
        <div className="container-fluid padding-side" data-aos="fade-up">
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            <div>
              <h3 className="display-3 fw-normal text-center">Fresh Vegetables</h3>
            </div>
            <Link to="/vegetables" className="btn btn-arrow btn-primary mt-3">
              <span style={{ color: 'white' }}>View All <i className="fas fa-arrow-right ms-2"></i></span>
            </Link>
          </div>

          <div className="row mt-5">
            {/* Ginger */}
            <div className="col-md-6 col-lg-3 mb-4">
              <div className="product-card position-relative bg-white rounded-4 overflow-hidden p-3">
                <span className="organic-badge">Organic</span>
                <img src={gingerImg} alt="Fresh Ginger" className="img-fluid rounded-4" style={{ height: '200px', width: '100%', objectFit: 'cover' }} />
                <div className="product-content text-center mt-3">
                  <h4 className="h5 fw-normal">Fresh Ginger</h4>
                  <p className="text-muted">1 kg pack</p>
                  <p><span className="price-tag">Rs.137</span></p>
                </div>
              </div>
            </div>
            {/* Thyme */}
            <div className="col-md-6 col-lg-3 mb-4">
              <div className="product-card position-relative bg-white rounded-4 overflow-hidden p-3">
                <span className="organic-badge">Organic</span>
                <img src={thymeImg} alt="Fresh Thyme" className="img-fluid rounded-4" style={{ height: '200px', width: '100%', objectFit: 'cover' }} />
                <div className="product-content text-center mt-3">
                  <h4 className="h5 fw-normal">Fresh Thyme</h4>
                  <p className="text-muted">1 kg pack</p>
                  <p><span className="price-tag">Rs.500</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <br /><br />

      {/* Certificates Section */}
      <section id="certificates">
        <div className="container-fluid padding-side" data-aos="fade-up">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h3 className="display-3 fw-normal">Certificates & Compliances</h3>
            </div>
          </div>

          <div className="row g-4 justify-content-center">
            {/* ISO Certification */}
            <div className="col-md-6 col-lg-4">
              <div className="certificate-card bg-white p-4 rounded-4 shadow-sm h-100">
                <div className="d-flex align-items-center mb-3 justify-content-center">
                  <img src={isoImg} alt="ISO Certification" />
                </div>
                <div className="text-center">
                  <p className="mb-2"><strong>ISO 9001:2015</strong></p>
                </div>
              </div>
            </div>

            {/* FSSAI Certification */}
            <div className="col-md-6 col-lg-4">
              <div className="certificate-card bg-white p-4 rounded-4 shadow-sm h-100">
                <div className="d-flex align-items-center mb-3 justify-content-center">
                  <img src={fssaiImg} alt="FSSAI Certification" style={{ width: '70%' }} />
                </div>
                <div className="text-center">
                  <p className="mb-2"><strong>FSSAI</strong></p>
                </div>
              </div>
            </div>

            {/* MSME Certification */}
            <div className="col-md-6 col-lg-4">
              <div className="certificate-card bg-white p-4 rounded-4 shadow-sm h-100">
                <div className="d-flex align-items-center mb-3 justify-content-center">
                  <img src={msmeImg} alt="MSME Certification" style={{ width: '40%' }} />
                </div>
                <div className="text-center">
                  <p className="mb-2"><strong>MSME</strong></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      {/* <section id="footer">
        <hr className="text-black" />
        <div className="container-fluid padding-side padding-small" data-aos="fade-up">
          <footer className="row">
            <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
              <h4 className="display-6 fw-normal">Quick links</h4>
              <ul className="nav flex-column">
                <li className="nav-item mb-2"><Link to="/" className="p-0 text-dark">Home</Link></li>
                <li className="nav-item mb-2"><Link to="/agroabout" className="p-0 text-dark">About Us</Link></li>
                <li className="nav-item mb-2"><Link to="/vegetables" className="p-0 text-dark">Vegetables</Link></li>
                <li className="nav-item mb-2"><Link to="/spices" className="p-0 text-dark">Spices</Link></li>
                <li className="nav-item mb-2"><Link to="/acontact" className="p-0 text-dark">Contact Us</Link></li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-3 offset-lg-1 mb-4 mb-lg-0"></div>
            <div className="col-md-6 col-lg-3 offset-lg-1 mb-4 mb-lg-0">
              <p className="m-0">© Copyright 2024 FreshHarvest.</p>
              <p>Farm Fresh Organic Vegetables & Fruits<br /> Delivered with love from our family to yours</p>
            </div>
          </footer>
        </div>
      </section> */}
    </div>
  );
};

export default AgroIndex;